
import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '@/components/HeroSection';
import SEOMetadata from '@/components/SEOMetadata';
import { webPageStructuredData } from '@/data/structuredData';
import ValueStatementSection from '@/components/paketinfo/ValueStatementSection';
import DecisionPathSection from '@/components/paketinfo/DecisionPathSection';
import ProcessStepsSection from '@/components/paketinfo/ProcessStepsSection';
import BookingCTASection from '@/components/paketinfo/BookingCTASection';
import TestimonialsSection from '@/components/coaching/TestimonialsSection';

const Paketinfo = () => {

  return (
    <main>
      <SEOMetadata
        metaTitle="Welches Coaching-Paket passt zu dir? | Jörg Hörmann"
        metaDescription="Finde das richtige Coaching-Paket: Einzelsitzungen oder Pakete für Finanzcoaching und Executive Coaching. Flexible Formate, transparente Preise."
        pageName="Paketinfo"
        primaryLink="/paketinfo"
        title="Welches Coaching-Paket passt zu dir?"
        description="Coaching-Pakete im Überblick: flexibel, individuell und transparent."
        canonicalUrl="https://joerg-hoermann.de/paketinfo"
        keywords="Coaching Pakete, Finanzcoaching Preise, Executive Coaching Pakete, Coaching Einzelsitzung"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(webPageStructuredData({
            name: "Welches Coaching-Paket passt zu dir?",
            description: "Coaching-Pakete im Überblick: Einzelsitzungen oder Pakete für Finanzcoaching und Executive Coaching.",
            url: "https://joerg-hoermann.de/paketinfo"
          }))}
        </script>
      </Helmet>
      <HeroSection
        title="Welches Paket passt zu dir?"
        subtitle="Flexibel und individuell"
        description="Du möchtest flexibel starten oder überlegst, ob ein Paket für dein Anliegen sinnvoll ist? Im kostenlosen Erstgespräch klären wir gemeinsam, welches Format zu dir, deinem Thema und deinem Tempo passt. Ganz ohne Verpflichtung – aber mit Klarheit."
        backgroundClass="bg-joerg-50"
      />

      <ValueStatementSection />
      <DecisionPathSection />
      <ProcessStepsSection />
      
      {/* CTA Section with neuropsychological optimization */}
      <BookingCTASection />
      
      {/* Testimonials provide social proof */}
      <TestimonialsSection />
    </main>
  );
};

export default Paketinfo;
